import { useTheme } from "@/components/theme-provider";
import { useState } from "react";

// Theme icon component that shows a preview of the theme colors
function ThemeIcon({ themeName }: { themeName: string }) {
  return (
    <div className="flex gap-0.5">
      <div data-theme={themeName} className="w-2 h-4 -my-1 rounded-l-lg bg-primary" />
      <div data-theme={themeName} className="w-2 h-4 -my-1 bg-secondary" />
      <div data-theme={themeName} className="w-2 h-4 -my-1 rounded-r-lg bg-accent" />
    </div>
  );
}

export function ModeToggle({ className }: { className?: string }) {
  const { theme, setTheme, availableThemes } = useTheme();
  const [searchQuery, setSearchQuery] = useState("");

  // Helper function to capitalize theme names for display
  const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

  // Filter themes based on search query
  const filteredThemes = availableThemes.filter(themeName =>
    themeName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className={`dropdown dropdown-start flex py-1 w-full ${className || ""}`}>
      {/* Dropdown Trigger - now shows current theme's colors */}
      <span tabIndex={0} role="button" className="flex w-full rounded-lg">
        <div className="flex items-center gap-2">
          <ThemeIcon themeName={theme} />
          <span>{capitalize(theme)}</span>
        </div>
      </span>

      {/* Dropdown Content */}
      <div
        tabIndex={0}
        className="dropdown-content z-[1] bg-base-200 rounded-box w-64 p-2 mt-2 shadow-lg"
      >
        {/* Search input */}
        <div className="sticky top-0 z-10 bg-base-200 pb-2">
          <input
            type="text"
            placeholder="Search themes..."
            className="input input-bordered input-sm w-full"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Theme list */}
        <div className="max-h-[60vh] overflow-y-auto scrollbar-thin scrollbar-thumb-base-300 scrollbar-track-base-200">
          {filteredThemes.map((themeName) => (
            <button
              key={themeName}
              className={`flex items-center justify-between w-full px-3 py-2 hover:bg-base-300 rounded-lg transition-colors ${
                theme === themeName ? "bg-base-300" : ""
              }`}
              onClick={() => setTheme(themeName)}
            >
              <span className="text-sm">{capitalize(themeName)}</span>
              <ThemeIcon themeName={themeName} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
